const SectionPricing = Class(
	/**
	 * @lends {SectionPricing#}
	 */
	{

		bodyClass: 'small-nav',
		menuItem: 'pricing',
		_listCount :0,

		draw() {
			const prefix = 'b2b.pricing.packs.new';
			this.node = mkE({
				tag: 'div',
				id: 'SectionPricing',
				els: [
					{
						tag: 'div',
						id: 'hero',
						className: 'container fade',
						els: [
							{
								tag: 'h1',
								innerHTML: t('b2b.pricing.hero.h1'),
							},
						],
					},
					{
						tag: 'div',
						className: 'container mb-5 pricing__packs fade',
						els: [
							{
								tag: 'div',
								className: 'scroll',
								style: {
									// inline to prevent jumping
									display: 'grid',
									gridTemplateColumns: 'repeat(4, 1fr)',
									gap: '20px',
									alignItems: 'flex-start',
									wordBreak: 'break-word',
								},
								els: this._drawPack(prefix),
							},
						],
					},
					{
						tag: 'div',
						className: 'events__list',
						id: 'events',
						els: [
							{
								tag: 'div',
								className: 'container events__list__header',
								els: [
									{
										tag: 'h2',
										innerHTML: t('b2b.pricing.events.list.h1'),
									},
									{
										tag: 'p',
										innerHTML: t('b2b.pricing.events.list.h2'),
									},
								],
							},
							new T.EventsList(this, {
								list: {
									count: D.CSS.brTablet ? 4 : 10,
									featured: false,
									simpleHeader: true,
								},
							}),
						],
					},
				],
			}).append(this.layout.ct());

			this.node.querySelectorAll('i[data-type]').forEach(item => {
				const target = item.parentElement;
				addClassName(target, 'tippy-container');
				this.tippy = tippy(target, {
					theme: 'rg1',
					interactiveBorder: 20,
					arrow: true,
					onTrigger: (instance, event) => {
						const node = mkE({
								tag: 'div',
								els: [
									this._drawTaskVideo(item.dataset.type, prefix),
								],
							},
						);
						instance.setContent(node);
						node.querySelector('video')?.play();
					},
				});
			});

			this.apiCall.call();
		},

		_drawPack(prefix) {
			let re = [];
			for (let i = 1; i <= 4; i++) {
				re.push({
					tag: 'article',
					className: `pack pack--${i}`,
					els: [
						i === 2 ? {
							tag: 'div',
							className: 'pack__popular',
							innerHTML: t(`${prefix}.${i}.popular`),
						} : '',
						{
							tag: 'div',
							className: 'h3 pack__name',
							els: [
								{
									tag: 'span',
									innerHTML: t(`${prefix}.${i}.name`),
								},
							],
						},
						{
							tag: 'div',
							className: 'pack__includes',
							innerHTML: t(`b2b.pricing.pack.includes`) + ':',
						},
						{
							tag: 'div',
							className: 'pack__price',
							els: [
								{
									tag: 'small',
									innerHTML: [
										t(`b2b.pricing.pack.price_from`, 'from') +
										(i === 4
											? ' <s><b>' + t(`${prefix}.${i}.price_from`) +
											'</b></s>'
											: '') +
										(i === 4
											? '<div class=\'discount\'>' +
											t(`${prefix}.${i}.price_discount`) + '</div>'
											: ''),
									],
								},
								{
									tag: 'div',
									className: 'h2',
									innerHTML: t(`${prefix}.${i}.price`),
								},
							],
						},
						{
							tag: 'div',
							className: 'pack__btn',
							els: [
								{
									tag: 'a',
									className: 'button button-pink button-multiline',
									innerHTML: t(`b2b.pricing.pack.btn`),
									href: D.url('/contact-us?ref=pricing'),
								},
							],
						},

						{
							tag: 'div',
							className: 'pack__content',
							innerHTML: this.formatContent(t(`${prefix}.${i}.content`)),
						},
					],
				});

			}
			return re;
		},

		formatContent(content) {
			content = '\n' + content;
			const lines = content.split('\n');
			let result = '';
			let inList = false;
			let listIndex = 1;
			let isFirst = true;

			for (let line of lines) {
				line = line.trim();

				if (line.startsWith('<b>') || isFirst) {
					isFirst = false;
					if (inList) {
						result += '</ul>';
						inList = false;
					}
					result += `<div>${line}</div>`;
					inList = true;
					result += `<ul class="list list-${listIndex}">`;
					listIndex++;
				} else {
					if (inList) {
						result += `<li>${line}</li>`;
					} else {
						result += `<div>${line}</div>`;
					}
				}
			}

			if (inList) {
				result += '</ul>';
			}

			this._listCount = listIndex;

			return result;
		},

		_tasks: {},

		_drawTaskVideo(task) {
			if (!this._tasks[task]) {
				let video = {
					tag: 'a',
					onclick: this._openTaskVideo,
					className: 'how-to-video',
					href: `/assets/videos/how-to/${task}.mp4`,
					els: [
						{
							tag: 'video',
							src: `/assets/videos/how-to/${task}_sm.mp4`,
							width: 132,
							height: 132,
							muted: 'muted',
							attr: {
								preload: 'auto',
								autoplay: 'true',
								loop: 'true',
								playsinline: 'true',
							},
						},
					],
				};
				if (task === 'coder' || task === 'touchme') {
					video = {
						tag: 'span',
						className: `how-to-video`,
					};
				}
				this._tasks[task] = mkE({
					tag: 'div',
					id: 'how-to-play-new',
					className: `pack__task how-to-${task}`,
					els: [
						video,
						{
							tag: 'div',
							className: 'title',
							text: D.Lang.get('how-to.' + task + '.caption2'),
						},
						{
							tag: 'div',
							className: 'descr',
							text: D.Lang.get('how-to.' + task + '.description'),
						},
						D.CSS.brTablet ? {
							tag: 'a',
							className: 'close',
							onclick: this._closeTippy,
							text: t('close'),
						} : '',
					],
				});
			}

			return this._tasks[task];
		},

		_closeTippy(e) {
			e.preventDefault();
			e.cancelBubble = true;
			this.tippy.hide();
		},

		_openTaskVideo(e) {
			e.preventDefault();
			e.cancelBubble = true;
			let src = e.currentTarget.href;
			if (screen.width < 768) {
				if (this._video.src !== window.location.origin + src) {
					this._video.src = src;
				}
				this._video.muted = false;
				this._video.autoplay = true;
				this._video.loop = false;
				if (this._video.readyState > 3) {
					this.onVideoCanPlay();
				} else {
					this._video.addEventListener('canplay', this.onVideoCanPlay);
				}
			} else {
				T.Popup.clip(src, 768, 768);
			}
			return false;
		},

		_equalizeListHeights() {
			const lists = this._listCount;

			for (let i = 1; i <= lists; i++) {
				const elements = document.querySelectorAll(`.list.list-${i}`);
				let maxHeight = 0;

				// Reset height and find max
				elements.forEach(el => {
					el.style.height = 'auto';
					maxHeight = Math.max(maxHeight, el.offsetHeight);
				});

				// Apply max height
				elements.forEach(el => {
					el.style.height = `${maxHeight}px`;
				});
			}
		},

		onShow() {
			this.fadeOnShow();
			this._equalizeListHeights();
		},

		onScroll() {
			this.fadeOnScroll();
		},

	},
	Section,
);

